/* Auto-generated by scripts/generate-version.js — do not edit by hand. */
import { AppVersionInfo } from '../interfaces/app-version.interface';

/** Fingerprint of the JS bundle currently running in the browser. */
export const APP_VERSION: AppVersionInfo = {
  "version": "6011-f5e473e906af26230ab2ccf77b824c01eb257a7f",
  "buildTime": "2026-10-05T10:28:21.926Z"
};
